<template>
    <div class="w-full mb-3">
        <Button label="Сбросить" @click="clear()" icon="pi pi-refresh" iconPos="right" severity="secondary" class="p-button-sm border-round-md border-0 text-xs font-medium"/>
    </div>
    <DataTable v-if='wallets' :value="wallets" responsiveLayout="scroll" v-model:filters="filters"
        @page="onPage($event)" @sort="onSort($event)" @filter="onFilter($event)" filterDisplay="menu" 
        :globalFilterFields="['_id', 'is_blockchain', 'user_id', 'type', 'created_at']" 
        lazy paginator :rows="lazyParams.rows" :rowsPerPageOptions="[5, 10, 20, 50, 100, 200, 300, 400, 500]" :totalRecords="total" :loading="loading" >

        <Column field="_id" sortable filterMatchMode="contains" :showFilterMatchModes="false" :exportable="false">
            <template #header>
                <span class="text-xs font-medium">ID</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-1 text-xs vertical-align-middle justify-content-start align-items-center">
                    <span class="flex my-auto overflow-hidden" style="max-width:5em">
                        <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                            {{ data.id }}
                        </span>
                    </span>...
                    <Button @click="copy(data.id)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                </div> 
            </template>
        </Column>

        <Column field="more">
            <template #header>
                <span class="text-xs font-medium">Подробно</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 vertical-align-middle justify-content-start">
                    <Button label="Кошелек" @click="goToWallet(data._id)" class="p-button-sm border-round-md border-0 text-xs font-medium" severity="info" />  
                    <Button @click="goToWallet(data._id, true)" class="p-button-sm border-round-md border-0 text-xs font-medium" icon="pi pi-external-link" severity="info" outlined/>  
                </div>
            </template>
        </Column>

        <!-- <Column field="type" :showFilterMenu="true" :showFilterMatchModes="false" :showApplyButton="false" :showClearButton="true">
            <template #header>
                <span class="text-xs font-medium">Тип</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="types" placeholder="Все" class="p-column-filter" :showClear="false">
                    <template #option="slotProps">
                        <div class="inline-block text-sm cursor-pointer align-items-center" >
                            <span class="flex">{{GetWalletNameByLabel(slotProps.option)}}</span>
                        </div>
                    </template>
                </Dropdown>
            </template>
            <template #body="{ data }">
                <div v-if="data.type" class="text-xs">
                    <span class="text-xs p-1 border-round-md" :class="getClassByLabel('virtual')">{{ GetWalletNameByLabel(data.type) }}</span>
                </div>
            </template>
        </Column> -->

        <Column field="ext_type" :showFilterMenu="true" :showFilterMatchModes="false" :showApplyButton="false" :showClearButton="true">
            <template #header>
                <span class="text-xs font-medium">Внеш.тип</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="ext_types" placeholder="Все" class="p-column-filter" :showClear="false">
                    <template #option="slotProps">
                        <div class="inline-block text-sm cursor-pointer align-items-center" >
                            <span class="flex">{{GetWalletNameByLabel(slotProps.option)}}</span>
                        </div>
                    </template>
                </Dropdown>
            </template>
            <template #body="{ data }">
                <div v-if="data.ext_type" class="text-xs">
                    <span class="text-xs p-1 border-round-md" :class="getClassByLabel(data.ext_type)">{{ GetWalletNameByLabel(data.ext_type) }}</span>
                </div>
            </template>
        </Column>

        <Column field="description">
            <template #header>
                <span class="text-xs font-medium">Описание</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 vertical-align-middle justify-content-start">
                    <span v-if="data.description" class="text-sm flex flex-row my-auto">
                        {{ data.description }}
                    </span>
                </div>
            </template>
        </Column>

        <Column field="user_id" filterField="user_id" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs font-medium">Ledger UID</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <div v-if="data.user_id" class="flex flex-row gap-1 text-xs vertical-align-middle justify-content-start align-items-center">
                    <span class="flex my-auto overflow-hidden" style="max-width:5em">
                        <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                            {{ data.user_id }}
                        </span>
                    </span>...
                    <Button @click="copy(data.user_id)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                    <Button @click="goToUser(data.user_id)" icon="pi pi-external-link" iconPos="right" size="small" outlined severity="info" class="border-0" />
                </div> 
            </template>
        </Column>

        <Column field="accounts">
            <template #header>
                <span class="text-xs font-medium">Счета</span>
            </template>
            <template #body="{data}">
                <div v-if="data.accounts" class="text-sm flex flex-row vertical-align-middle justify-content-start">
                    <span class="text-sm flex flex-row my-auto">
                        {{ (data.accounts && data.accounts.length) ? data.accounts.length : 0 }}
                    </span>
                    <Button v-if="data.accounts.length" @click="detail_info(data.accounts)" :disabled="!data.accounts.length" 
                        icon="pi pi-eye" iconPos="right" outlined
                        class="p-button-sm border-round-md border-0 text-xs font-medium ml-2 surface-100 text-600"/>  
                </div>
            </template>
        </Column>

        <Column field="created_at" sortable filterField="created_at" dataType="date">
            <template #header>
                <span class="text-xs font-medium">Создан</span>
            </template>
            <template #body="slotProps">
                <span class="text-xs flex flex-row">
                    {{ formatDate(slotProps.data.created_at) }}
                </span>
            </template>
        </Column>

        <Column field="updated_at">
            <template #header>
                <span class="text-xs font-medium">Обновлен</span>
            </template>
            <template #body="slotProps">
                <span class="text-xs flex flex-row">
                    {{ formatDate(slotProps.data.updated_at) }}
                </span>
            </template>
        </Column>

        <template #footer>
            <span class="text-sm text-600 font-medium">
                Всего {{ total }} кошельков 
            </span>
        </template>

    </DataTable>
    <Dialog header="info" v-model:visible="displayDialog" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" >
        <div class="w-full mb-3">
            <span v-for="(d,k) in detail_data" class="block mb-2">
                {{ k }}: <span class="font-medium">{{ d }}</span> <br>
            </span>
        </div>
    </Dialog>
</template>


<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import { useRoute } from 'vue-router'

export default {
    props: ['wallets', 'total', 'account_id', 'loading', 'defaultParams'],
    data() {
        return {
            displayDialog: false,
            detail_data: null,
            statuses: ['pending', 'success', 'failed', 'completed', 'canceled'],
            types:      ['service', 'freeze', 'liquidity', 'withdraw', 'deposit', 'virtual', 'virtual_debit'],
            ext_types:  ['deposit', 'vcard', 'partner', 'merchant', 'comission', 'vendor', 'withdraw', 'liquidity', 'freeze', 'service', 'fund'],
            lazyParams: this.defaultParams,
            filters: {
                _id: {value: '', matchMode: 'contains'},
                is_blockchain: {value: null, matchMode: 'contains'},
                user_id: {value: '', matchMode: 'contains'},
                type: {value: '', matchMode: 'contains'},
                ext_type: {value: '', matchMode: 'contains'},
                created_at: {value: '', matchMode: 'contains'},
            },
            sort: {
                field: '_id',
                order: 1
            },
            blockTypes: [
                {label: 'Все', value: null},
                {label: 'Блокчейн', value: true},
                {label: 'Виртуальный', value: false},
            ]
        }
    },
    methods: {
        getFormatAmount(value, currency, digits=2) {
            return this.helper.format_amount(value, currency, digits)
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        goToUser(id){
            if(!id) return
            const routeData = this.$router.resolve({ path: `/admin/users/?ledger_id=${id}` }) 
            window.open(routeData.href, '_blank');
        },
        goToWallet(id, new_tab = false){
            if(!id) return
            if(!new_tab) this.$router.push({ path: '/admin/wallet/' + id })
            else {
                const routeData = this.$router.resolve({ path: '/admin/wallet/' + id }) 
                window.open(routeData.href, '_blank');
            }
        },
        getShortId(value){
            if(!value) return ''
            return '..'+this.helper.get_short_id(value)
        },
        detail_info(data) {
            this.displayDialog = true
            this.detail_data = data
        },
        onPage(event) {
            this.lazyParams = event
            this.$emit('lazyParams', this.lazyParams)
        },
        onSort(event) {
            if(event.sortField && event.sortOrder){
                this.sort = {
                    field: event.sortField,
                    order: event.sortOrder
                }
            } else {
                this.sort = {
                    field: 'date_created',
                    order: -1
                }
            }
            this.lazyParams.sort = this.sort
            this.$emit('lazyParams', this.lazyParams)
        },
        onFilter() {
            this.lazyParams.filters = this.filters
            this.$emit('filter', this.filters)
        },
        clear(){
            this.filters = {
                _id: {value: '', matchMode: 'contains'},
                is_blockchain: {value: null, matchMode: 'contains'},
                user_id: {value: '', matchMode: 'contains'},
                type: {value: '', matchMode: 'contains'},
                created_at: {value: '', matchMode: 'contains'},
            }
            this.lazyParams.filters = this.filters
            this.$emit('filter', this.filters)
        },
        getClassByLabel(label){
            return this.helper.GetClassByLabel(label)
        },
        GetWalletNameByLabel(label){
            return this.helper.GetWalletNameByLabel(label)
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()
    },
}
</script>